import { render, staticRenderFns } from "./PassResetApplication.vue?vue&type=template&id=550cb22b&scoped=true"
import script from "./PassResetApplication.vue?vue&type=script&lang=js"
export * from "./PassResetApplication.vue?vue&type=script&lang=js"
import style0 from "./PassResetApplication.vue?vue&type=style&index=0&id=550cb22b&prod&scoped=true&lang=css"
import style1 from "./PassResetApplication.vue?vue&type=style&index=1&id=550cb22b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550cb22b",
  null
  
)

export default component.exports